/**
 * キーワード検索コンポーネント(画像検索に使う想定)
 */
export default {
    template: '#image_search_template',
    data() {
        return {
            // エンター検索用フラグ
            can_enter_search: false,
        };
    },
    props: {
        // 検索キーワード
        search_word: {
            type: String,
            default: '',
        },
    },
    computed: {
        // 検索キーワード
        local_search_word: {
            get() {
                return this.search_word;
            },
            set(value) {
                this.$emit('update:search_word', value);
            },
        },
        // プレースホルダー
        placeHolder: function () {
            return 'キーワード';
        },
    },
    emits: ['update:search_word', 'search-image'],
    methods: {
        // エンターキーによる検索実行
        enterSearch: async function () {
            if (!this.can_enter_search) {
                return;
            }
            await this.search();
            this.can_enter_search = false;
        },
        search: async function () {
            await this.emitSearchImage(this.local_search_word);
        },

        // -------------------------
        // emit
        // -------------------------

        /**
         * 指定ページのデータを取得する
         */
        emitSearchImage: function (searchWord) {
            this.$emit('search-image', searchWord);
        },
    }
};
